<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        <span>Inventurdetails</span>
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper virtual-padding" ref="contentWrapper">
      <!--<product-list :renderData="renderData" v-if="!isLoading"/>-->

      <v-virtual-scroll class="order_virtual-scroll" item-height="181" v-if="!isLoading"
                        :items="currentInventory" bench="1">
        <template v-slot:default="{index, item}">
          <v-card class="article-card_no-img-full-borders pl-6" :key="index">
            <div class="article-card__desc-no-img">
              {{ item.description }}
            </div>
            <div class="article-card__itemNo-no-img">
              Artikelnummer: {{ item.itemNo }}
            </div>
            <div class="article-card__ordered-type-no-img">
              {{ item.amount }} {{ item.unit | capitalize}}
            </div>
            <div class="article-card__price-no-img">
                        <span class="total-price">
                          {{ item.price | parsePrice2Digits }} €
                        </span>
              <span class="single-price">
                          Einzelpreis: {{ item.singlePrice | parsePrice2Digits }} €
                        </span>
            </div>
          </v-card>
        </template>
      </v-virtual-scroll>

      <v-container class="lastArticlesWrapper" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 10"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-list-item-avatar tile>

                </v-list-item-avatar>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="articleAmountCart">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePrice">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import router from "@/router";

export default {
  name: "singleInventory",

  props:['inventory'],

  data() {
    return {
      isLoading: true,
      fetchedInventory: null
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
    }),

    ...mapActions('inventory', {
      getInventoryById: 'getInventoryById'
    }),

    goBack() {
      router.go(-1)
    }
  },

  computed: {
    currentInventory() {
      if(this.inventory !== undefined) {
        return this.inventory.inventory.data
      }
      else {
        return this.fetchedInventory.data
      }
    }
  },

  mounted() {
    this.setHeaderVisibility()
    if(this.inventory === undefined) {
      this.getInventoryById(router.currentRoute.params.id).then(res => {
        this.fetchedInventory = JSON.parse(res.data.inventory_total)
        this.isLoading = false
      })
    }
    else {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>

</style>
